import {
  useGetExamResultSolutionSummaryQuery as useGetExaminationResultSolutionSummary,
  GetExamResultSolutionSummaryQuery as examResultSolutionSummaryType,
} from '../../generated/graphql';

export default useGetExaminationResultSolutionSummary;
export type { examResultSolutionSummaryType };
